import script from "./ApplyOpen.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplyOpen.vue?vue&type=script&setup=true&lang=js"

import "./ApplyOpen.vue?vue&type=style&index=0&id=27c22e8d&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27c22e8d"]])

export default __exports__